module.exports = __webpack_public_path__ + "img/vine.3af9c924.png";